import { useParams, Navigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SectionHero from '@/components/feature/sections/SectionHero';
import SectionTrustBar from '@/components/feature/sections/SectionTrustBar';
import SectionContentOverview from '@/components/feature/sections/SectionContentOverview';
import SectionAIBlock from '@/components/feature/sections/SectionAIBlock';
import SectionProcess from '@/components/feature/sections/SectionProcess';
import SectionWhyChooseUs from '@/components/feature/sections/SectionWhyChooseUs';
import SectionServiceAreas from '@/components/feature/sections/SectionServiceAreas';
import SectionTestimonials from '@/components/feature/sections/SectionTestimonials';
import SectionFAQ from '@/components/feature/sections/SectionFAQ';
import SectionFinalCTA from '@/components/feature/sections/SectionFinalCTA';
import { LOCATIONS_DATA } from '@/mocks/locations';

export default function LocationPage() {
  const { slug } = useParams<{ slug: string }>();
  const location = LOCATIONS_DATA.find(l => l.slug === slug);

  if (!location) return <Navigate to="/" replace />;

  return (
    <div className="font-sans">
      <Navbar />
      <main>
        {/* 1. Hero */}
        <SectionHero
          eyebrow={location.eyebrow}
          headline={location.h1}
          accentLine={location.accentLine}
          subheadline={location.subheadline}
          image={location.heroImage}
          imageAlt={'Roofing Services in ' + location.fullName + ' | All Done Roofing LLC'}
          cta="Request a Free Estimate"
        />

        {/* 2. Trust Bar */}
        <SectionTrustBar />

        {/* 3. Local Service Overview */}
        <SectionContentOverview
          eyebrow={'Serving ' + location.fullName}
          title={location.localOverview.title}
          titleAccent={location.localOverview.titleAccent}
          paragraphs={location.localOverview.paragraphs}
          features={location.localOverview.features}
          image={location.localOverview.image}
          imageAlt={'Roofing in ' + location.fullName}
        />

        {/* 4. AI Answer Block */}
        <SectionAIBlock
          eyebrow={'Roofing Services in ' + location.fullName}
          heading={location.aiBlock.heading}
          headingAccent={location.aiBlock.headingAccent}
          paragraphs={location.aiBlock.paragraphs}
        />

        {/* 5. Process */}
        <SectionProcess />

        {/* 6. Why Choose Us */}
        <SectionWhyChooseUs />

        {/* 7. Service Areas */}
        <SectionServiceAreas />

        {/* 8. Testimonials */}
        <SectionTestimonials />

        {/* 9. FAQ */}
        <SectionFAQ
          faqs={location.faqs}
          title={'Roofing FAQ for ' + location.city}
          subtitle={'Common questions about roofing services, costs, and process in ' + location.fullName + '.'}
        />

        {/* 10. Final CTA */}
        <SectionFinalCTA
          headline={'PROTECT ' + location.city.toUpperCase() + '.'}
          accentLine={'Premium roofing built for the Gulf Coast.'}
          subheadline={'Our GAF Certified team serves ' + location.fullName + ' with free inspections, honest estimates, and roofing systems built to outlast Gulf Coast weather. Schedule yours today.'}
          primaryCTA={'Get a Free Estimate in ' + location.city}
        />
      </main>
      <Footer />
    </div>
  );
}
